
<v-sheet class="basicConfigurator">
  <v-row class="header">
    <v-col>
      <h1 class="display-1">{{ title }}</h1>
    </v-col>
    <v-col>
      <v-row>
        <v-spacer/>
        <v-col cols="auto">
          <v-btn v-if="showBuyButton" :disabled="adding" :loading="adding" class="buyButtonTop" color="primary" right @click="addToBasket">
            <v-icon>{{ basketProductSubmission && basketProductSubmission.editing ? "save" : "add_shopping_cart" }}</v-icon>
            {{ buyButtonText }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <slot/>
  <v-row class="actionButtons" justify="center">
    <v-col cols="auto">
      <v-btn v-if="showBuyButton" :disabled="adding" :loading="adding" class="actionButton" color="primary" @click="addToBasket">
        <v-icon>{{ basketProductSubmission && basketProductSubmission.editing ? "save" : "add_shopping_cart" }}</v-icon>
        {{ buyButtonText }}
      </v-btn>
    </v-col>
  </v-row>

</v-sheet>
